import {VekaletUcretOranEntity} from "@/entity/VekaletUcretOranEntity";

export class VekaletUcretDonemEntity {
    baslangic_tarihi: Date| null=null;
    bitis_tarihi: Date| null=null;
    id: number | null = null;
    oranlar: Array<VekaletUcretOranEntity> | null = null;
    vekalet_ucret_id!: number;
    text!:string
}